export default __webpack_public_path__ + "static/22_34-395b0a9f1b0c603507a1ac34012aa5bd.png";